export default __webpack_public_path__ + "static/small-image-completely-1-c239edcb44951efb0d8341a338874953.png";